import { render, staticRenderFns } from "./AdminInvoiceView.vue?vue&type=template&id=60ce38f8&scoped=true"
import script from "./AdminInvoiceView.vue?vue&type=script&lang=js"
export * from "./AdminInvoiceView.vue?vue&type=script&lang=js"
import style0 from "./AdminInvoiceView.vue?vue&type=style&index=0&id=60ce38f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ce38f8",
  null
  
)

export default component.exports